export const IFRAME_ONLOAD = 'LEGACY_FRAME.IFRAME_ONLOAD';
